import { Divider } from "@mui/material";
import { ONBOARDING_OR_DIVIDER_SX } from "../features/organisations/onboarding/onboardingDesign.js";

interface Props {
  label?: string;
}

export const ButtonDivider = ({ label }: Props) => {
  return <Divider sx={ONBOARDING_OR_DIVIDER_SX}>{label}</Divider>;
};
